import React from "react"
import { useContext } from "react"
import { useTranslation } from "react-i18next"
import { useMediaQuery } from "react-responsive"
import { Link, useMatch } from "react-router-dom"

import PropTypes from "prop-types"
import MobileMenu from "../MobileMenu/MobileMenu";
import LanguageSwitcher from "../../components/LanguageSwitcher/LanguageSwitcher"
import ModelsDropDown from "../../components/ModelsDropDown/ModelsDropDown"
import { AppContext } from "../../context/AppContext"
import useScroll from "../../hooks/use-Scroll"
import { getSelectedModel } from "../../hooks/use-selected-model"

import { getCmsAssetsUrl } from "../../helpers/general"

import styles from "./Header.module.scss"

const assetsUrl = getCmsAssetsUrl()

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ query: "(max-width:992px)" })
  return isMobile ? children : null
}
const PC = ({ children }) => {
  const isPc = useMediaQuery({ query: "(min-width: 993px)" })
  return isPc ? children : null
}

const Header = ({ data, inConfiguration, children, relativePosition }) => {
  const { t, i18n } = useTranslation()
  const home = useMatch("/" + i18n.language)
  const homeConfigure = useMatch("/" + i18n.language + "/configure")
  const model = getSelectedModel()
  const summaryPage = useMatch(
    "/" + i18n.language + "/configure/" + model + "/summary"
  )
  
  const configurePage = useMatch("/" + i18n.language + "/configure/:charger")
  
  // Determine if header should have relative positioning
  const shouldUseRelativePosition = relativePosition || 
    (configurePage && !homeConfigure) ||
    false // Add more conditions as needed

  const appContext = useContext(AppContext)
  const { store } = appContext

  const values = null
  const y = useScroll()
  const windowWidth = window.innerWidth
  const isViewer = false
  const companyName = values?.EMPRESA_NOMBRE || "Ingeteam"
  const logoFileName = values?.EMPRESA_LOGO || "ingeteamev.svg"

  return (
    <header
      className={[
        styles.header,
        inConfiguration === true ? styles.inConfiguration : "",
        relativePosition === true ? styles.relativePosition : "",
        shouldUseRelativePosition ? styles.relativePosition : "",
        y > 2 && windowWidth < 993 ? styles.isScrolling : " ",
      ].join(" ")}
    >
      <div className={styles.headerContainer}>
        {/* <Mobile>
          {!isViewer && (
            <div className={styles.contentMobildioma}>
              <div className={styles.idiomasMobil}>
                <LanguageSwitcher />
              </div>
            </div>
          )}
        </Mobile>{" "} */}
        <div className={styles.headerLeft}>
          <Link to="/">
            <div className={styles.placeHolderLogo}>
              {!isViewer ? (
                <img
                  src={`${assetsUrl}/${store.initConfig.images}/logos/${logoFileName}`}
                  alt={companyName}
                />
              ) : null}
            </div>
          </Link>
          <div className={styles.titular}>{data.titulo}</div>
        </div>

        <div className={styles.headerRight}>
          <PC>
            {configurePage === null ? (
              <div className={styles.modelsDropDown}>
                <ModelsDropDown />
              </div>
            ) : (
              ""
            )}

            {home !== null || summaryPage !== null ? (
              <div className={styles.configurateNowLink}>
                <Link
                  className={styles.button}
                  to={`/${i18n.language}/configure`}
                >
                  {t("configurate now")}
                </Link>
              </div>
            ) : (
              ""
            )}
            {!isViewer && (
              <div className={styles.contentLang}>
                <img
                  src={`${assetsUrl}/images/ingeteamev/icons/globe.svg`}
                  alt="Globe"
                  className={styles.globeIcon}
                />
                <LanguageSwitcher />
              </div>
            )}
          </PC>

          <Mobile>
            <MobileMenu />
          </Mobile>
        </div>

        {children}
      </div>
    </header>
  )
}

export default Header

Header.propTypes = {
  inConfiguration: PropTypes.bool,
  relativePosition: PropTypes.bool,
  data: PropTypes.shape({
    title: PropTypes.string,
  }),
  children: PropTypes.node,
}

Header.defaultProps = {
  inConfiguration: false,
  relativePosition: false,
  children: null,
}
